var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desk_alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M12.917 4.16669C14.0874 4.16669 14.6726 4.16669 15.0929 4.44757C15.2749 4.56917 15.4312 4.72542 15.5528 4.9074C15.8337 5.32778 15.8337 5.91297 15.8337 7.08335V15C15.8337 16.5714 15.8337 17.357 15.3455 17.8452C14.8573 18.3334 14.0717 18.3334 12.5003 18.3334H7.50033C5.92898 18.3334 5.1433 18.3334 4.65515 17.8452C4.16699 17.357 4.16699 16.5714 4.16699 15V7.08335C4.16699 5.91297 4.16699 5.32778 4.44788 4.9074C4.56947 4.72542 4.72572 4.56917 4.90771 4.44757C5.32808 4.16669 5.91327 4.16669 7.08366 4.16669",
    stroke: "#61616F",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M7.5 4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H10.8333C11.7538 2.5 12.5 3.24619 12.5 4.16667C12.5 5.08714 11.7538 5.83333 10.8333 5.83333H9.16667C8.24619 5.83333 7.5 5.08714 7.5 4.16667Z",
    stroke: "#61616F",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 55",
    d: "M7.5 10L12.5 10",
    stroke: "#61616F",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 58",
    d: "M7.5 13.3333L10.8333 13.3333",
    stroke: "#61616F",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListings);
export default __webpack_public_path__ + "static/media/listings.e80fdcbf59304fd21e8ca26884f50fdd.svg";
export { ForwardRef as ReactComponent };